export default "__VITE_ASSET__KambheoT__"